(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-bra-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-guide-calculator]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const form = guide.querySelector('[data-guide-calc-form]');
      const result = guide.querySelector('[data-guide-calc-result]');
      const message = guide.querySelector('[data-guide-calc-message]');
      if (!dataNode || !form || !result || !message) return;
      let rows = [];
      try { rows = JSON.parse(dataNode.textContent || '[]'); } catch (error) { return; }
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const under = Number(form.elements.underbust.value);
        const over = Number(form.elements.overbust.value);
        result.hidden = true;
        message.textContent = '';
        if (!Number.isFinite(under) || !Number.isFinite(over) || under <= 0 || over <= 0 || over <= under) { message.textContent = 'Please enter valid measurements, with bust larger than band.'; return; }
        const ranges = rows.reduce((list, row) => list.some((item) => item.label === row.underRange) ? list : list.concat({ label: row.underRange, bounds: row.underRange.split('-').map(Number) }), []);
        const range = ranges.reduce((best, item) => { const distance = under < item.bounds[0] ? item.bounds[0] - under : under > item.bounds[1] ? under - item.bounds[1] : 0; return !best || distance < best.distance ? { item, distance } : best; }, null);
        if (!range || range.distance > 4) { message.textContent = 'These measurements are outside our current guide. Please contact VELOURA for personal help.'; return; }
        const candidates = rows.filter((row) => row.underRange === range.item.label);
        const match = candidates.reduce((best, row) => !best || Math.abs(row.overCm - over) < Math.abs(best.overCm - over) ? row : best, null);
        if (!match || Math.abs(match.overCm - over) > 3) { message.textContent = 'We could not find a close chart match. Please review the chart or contact us.'; return; }
        guide.querySelector('[data-guide-calc-uk]').textContent = match.uk;
        guide.querySelector('[data-guide-calc-int]').textContent = match.international;
        guide.querySelector('[data-guide-calc-us]').textContent = match.us;
        guide.querySelector('[data-guide-calc-fr]').textContent = match.french;
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-fit-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-guide-hub]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const under = guide.querySelector('[data-hub-under]');
      const over = guide.querySelector('[data-hub-over]');
      const result = guide.querySelector('[data-hub-result]');
      if (!dataNode || !under || !over || !result) return;
      let rows = [];
      try { rows = JSON.parse(dataNode.textContent || '[]'); } catch (error) { return; }
      const reset = () => { result.hidden = true; };
      under.addEventListener('change', () => {
        const matches = rows.filter((row) => row.underRange === under.value);
        over.innerHTML = '<option value="">Select your overbust</option>';
        matches.forEach((row) => { const option = document.createElement('option'); option.value = row.overCm; option.textContent = `${row.overCm} cm`; over.appendChild(option); });
        over.disabled = matches.length === 0; reset();
      });
      over.addEventListener('change', () => {
        const match = rows.find((row) => row.underRange === under.value && String(row.overCm) === over.value);
        if (!match) { reset(); return; }
        guide.querySelector('[data-hub-uk]').textContent = match.uk;
        guide.querySelector('[data-hub-int]').textContent = match.international;
        guide.querySelector('[data-hub-us]').textContent = match.us;
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-size-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-calculator]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const form = guide.querySelector('[data-calc-form]');
      const result = guide.querySelector('[data-calc-result]');
      const message = guide.querySelector('[data-calc-message]');
      if (!dataNode || !form || !result || !message) return;
      let rows = [];
      try { rows = JSON.parse(dataNode.textContent || '[]'); } catch (error) { return; }
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const under = Number(form.elements.underbust.value);
        const over = Number(form.elements.overbust.value);
        result.hidden = true;
        message.textContent = '';
        if (!Number.isFinite(under) || !Number.isFinite(over) || under <= 0 || over <= 0 || over <= under) { message.textContent = 'Please enter valid measurements, with bust larger than band.'; return; }
        const ranges = rows.reduce((list, row) => list.some((item) => item.label === row.underRange) ? list : list.concat({ label: row.underRange, bounds: row.underRange.split('-').map(Number) }), []);
        const range = ranges.reduce((best, item) => { const distance = under < item.bounds[0] ? item.bounds[0] - under : under > item.bounds[1] ? under - item.bounds[1] : 0; return !best || distance < best.distance ? { item, distance } : best; }, null);
        if (!range || range.distance > 4) { message.textContent = 'These measurements are outside our current guide. Please contact VELOURA for personal help.'; return; }
        const candidates = rows.filter((row) => row.underRange === range.item.label);
        const match = candidates.reduce((best, row) => !best || Math.abs(row.overCm - over) < Math.abs(best.overCm - over) ? row : best, null);
        if (!match || Math.abs(match.overCm - over) > 3) { message.textContent = 'We could not find a close chart match. Please review the Bra Size Guide or contact us.'; return; }
        guide.querySelector('[data-calc-uk]').textContent = match.uk;
        guide.querySelector('[data-calc-int]').textContent = match.international;
        guide.querySelector('[data-calc-us]').textContent = match.us;
        guide.querySelector('[data-calc-fr]').textContent = match.french;
        result.hidden = false;
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rows = [
      ['26-27','32','32AA','32A','85A','70A'],['26-27','33','32A','32B','85B','70B'],['26-27','34','32B','32C','85C','70C'],['26-27','35','32C','32D','85D','70D'],['26-27','36','32D','32DD','85DD','70DD'],
      ['28-29','34','34AA','34A','90A','75A'],['28-29','35','34A','34B','90B','75B'],['28-29','36','34B','34C','90C','75C'],['28-29','37','34C','34D','90D','75D'],['28-29','38','34D','34DD','90DD','75DD'],['28-29','39','34DD','34E','90E','75E'],
      ['30-31','36','36AA','36A','95A','80A'],['30-31','37','36A','36B','95B','80B'],['30-31','38','36B','36C','95C','80C'],['30-31','39','36C','36D','95D','80D'],['30-31','40','36D','36DD','95DD','80DD'],['30-31','41','36DD','36E','95E','80E'],
      ['32-33','38','38AA','38A','100A','85A'],['32-33','39','38A','38B','100B','85B'],['32-33','40','38B','38C','100C','85C'],['32-33','41','38C','38D','100D','85D'],['32-33','42','38D','38DD','100DD','85DD'],['32-33','43','38DD','38E','100E','85E']
    ];
    document.querySelectorAll('[data-veloura-fit-guide]').forEach((guide) => {
      const under = guide.querySelector('[data-fit-underbust]');
      const over = guide.querySelector('[data-fit-overbust]');
      const result = guide.querySelector('[data-fit-result]');
      if (!under || !over || !result) return;
      const resetResult = () => { result.hidden = true; };
      under.addEventListener('change', () => {
        const matches = rows.filter((row) => row[0] === under.value);
        over.innerHTML = '';
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = guide.dataset.overbustPlaceholder;
        over.appendChild(placeholder);
        matches.forEach((row) => {
          const option = document.createElement('option'); option.value = row[1]; option.textContent = `${row[1]} in`; over.appendChild(option);
        });
        over.disabled = matches.length === 0; over.value = ''; resetResult();
      });
      over.addEventListener('change', () => {
        const match = rows.find((row) => row[0] === under.value && row[1] === over.value);
        if (!match) { resetResult(); return; }
        guide.querySelector('[data-fit-primary]').textContent = match[3];
        guide.querySelector('[data-fit-us]').textContent = match[2];
        guide.querySelector('[data-fit-english]').textContent = match[3];
        guide.querySelector('[data-fit-french]').textContent = match[4];
        guide.querySelector('[data-fit-international]').textContent = match[5];
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
